<mat-drawer-container class="main-container" style="background-color: white;" autosize>
  <mat-drawer #drawer class="sidenav-drawer" class="drawer-style" mode="side" opened>
    <div class="mt-40">
    </div>
  </mat-drawer>

  <mat-drawer-content class="overflow-hidden">
    <div class="sidenav-content">

      <div class="row col-12 m-0 centerAlign">
        <div class="col-5 mt-5">
          <div class="entityDet-title">
            
              <form class="w-100" #regform="ngForm" (ngSubmit)="awsCognitoSignUp(regform)">
                <h2 class="justify-content-center d-flex w-100 fontweighthead">{{RegistrationHeading}}</h2>
                <!-- <h2 class="h2-reister">{{RegistrationHeading}}</h2> -->
                <div class="">
                  <div
                    [ngClass]="(firstnameControl.touched==true&&firstnameControl.invalid==true)?'left-column error-column': 'left-column'">
                    <label class="error-label"
                      *ngIf="firstnameControl.touched==true&&firstnameControl.invalid==true">First name is
                      required</label>
                    <label class="display-label" *ngIf="register.firstname!=null&&register.firstname!=''">First
                      name</label>
                    <input type="text" aria-label="Text" class="input-text-labeldesign" autocomplete="off"
                      [(ngModel)]="register.firstname" #firstnameControl="ngModel" name="fName" placeholder="First name"
                      required tabindex="1" />
                  </div>
                  <div
                    [ngClass]="(lastnameControl.touched==true&&lastnameControl.invalid==true)?'right-column error-column': 'right-column'">
                    <label class="display-label" *ngIf="register.lastname!=null&&register.lastname!=''">Last
                      name</label>
                    <label class="error-label" *ngIf="lastnameControl.touched==true&&lastnameControl.invalid==true">Last
                      name is required</label>
                    <input type="text" aria-label="Text" class="input-text-labeldesign" autocomplete="off"
                      [(ngModel)]="register.lastname" #lastnameControl="ngModel" placeholder="Last name" name="lname"
                      required tabindex="2" />
                  </div>
                </div>
                <div class="">
                  <div
                    [ngClass]="(emailControl.touched==true&&emailControl.invalid==true)?'single-column  error-column': 'single-column'" class="w-100">
                    <label class="display-label" *ngIf="register.email!=null&&register.email!=''">Email</label>
                    <label class="error-label" *ngIf="emailControl.touched==true&&emailControl.invalid==true">Email is
                      required</label>
                    <input type="text" aria-label="Text" class="input-text-labeldesign" autocomplete="off"
                      placeholder="Email" #emailControl="ngModel" [(ngModel)]="register.email" name="mail" required
                      tabindex="3" />
                  </div>
                </div>
                <div class="">
                  <div
                    [ngClass]="(orgControl.touched==true&&orgControl.invalid==true)?'single-column  error-column': 'single-column'" class="w-100">
                    <label class="display-label"
                      *ngIf="register.organizationId!=null&&register.organizationId!=''">Organization</label>
                    <label class="error-label" *ngIf="orgControl.touched==true&&orgControl.invalid==true">Organization
                      is required</label>
                    <select name="org" aria-label="Select" class="input-text-labeldesign"
                      style="height: 35px!important;padding: 0px!important;padding-left: 12px!important"
                      #orgControl="ngModel" [(ngModel)]="register.organizationId" autocomplete="off"
                      placeholder="Select Organization" (change)="SelectOrg($event.target.value)" required tabindex="4">
                      <option disabled selected value="null">Select organization</option>
                      <option *ngFor="let org of masterOrgs" value={{org.organizationId}}>{{org.organizationName}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="">
                  <div
                    [ngClass]="(passwordControl.touched==true&&passwordControl.invalid==true)?'left-column error-column': 'left-column'">
                    <label class="display-label" *ngIf="register.password!=null&&register.password!=''">Password</label>
                    <label class="error-label"
                      *ngIf="passwordControl.touched==true&&passwordControl.invalid==true">Password is required</label>
                    <input type="password" aria-label="Password" class="input-text-labeldesign" autocomplete="off"
                      [(ngModel)]="register.password" #passwordControl="ngModel" placeholder="Password" name="Pword"
                      required tabindex="5" />
                  </div>
                  <div
                    [ngClass]="(confirmpwdControl.touched==true&&confirmpwdControl.invalid==true)?'right-column error-column': 'right-column'">
                    <label class="display-label" *ngIf="ConfirmPassword!=null&&ConfirmPassword!=''">Confirm
                      password</label>
                    <label class="error-label"
                      *ngIf="confirmpwdControl.touched==true&&confirmpwdControl.invalid==true">Confirm password is
                      required</label>
                    <input type="password" aria-label="Confirm password" class="input-text-labeldesign"
                      autocomplete="off" [(ngModel)]="ConfirmPassword" #confirmpwdControl="ngModel"
                      placeholder="Confirm Password" name="Cnfpassword" required tabindex="6" />

                  </div>
                </div>

                <div class="button-row">
                  <button class="col-md-12 buttonstyle" mat-raised-button 
                  [disabled]="!regform.form.valid"
                  >Create account</button>
                </div>
                <!-- <div class=" pt-4 line col-md-12 inherit-display">
                  <mat-divider></mat-divider>
                </div>  -->
                <div class="button-row pt-2">               
                  <button class="col-md-12 buttonstyle" mat-raised-button (click)="Navigate()" >Sign in</button>
              </div>
              </form>                         
          </div>
        </div>       
        <div class="col-4 mt-5 pt-5 pl-5" >
          <!-- <img src="/assets/images/SI4.png" class="imgstyle pl-3" alt="HS logo"> -->
          <img src="/assets/images/image.png" alt="" class="imgstyle pl-3">
        </div>
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>